import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { switchMap, timer } from 'rxjs';
import { DEV_CONFIG } from '../../models/config.model';
import { StatusPageService } from '../../services/status-page.service';

@Component({
  selector: 'dev-status',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatProgressSpinnerModule, MatTooltipModule],
  templateUrl: './status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusComponent {
  private readonly statusPageService = inject(StatusPageService);
  private readonly config = inject(DEV_CONFIG);
  private readonly everyFiveMinutes = 1000 * 60 * 5;

  protected readonly page = toSignal(
    timer(0, this.everyFiveMinutes).pipe(switchMap(() => this.statusPageService.getStatusPage())),
  );

  openStatusPage(): void {
    globalThis.open(this.config.statusPageUrl);
  }

  getIcon(indicator: string): string {
    switch (indicator) {
      case 'none':
        return 'check_circle';
      case 'minor':
        return 'warning';
      case 'major':
        return 'error';
      default:
        return 'info';
    }
  }

  getColor(indicator: string): string {
    switch (indicator) {
      case 'none':
        return 'text-green-500';
      case 'minor':
        return 'text-orange-500';
      case 'major':
        return 'text-red-500';
      default:
        return 'text-slate-500';
    }
  }
}
